<vectronic-device-selector
  [allDeviceIds]="allDevices()"
  (colorChanged)="onColorChanged($event)"
  (setMapFocus)="setMapFocus($event)"
  (clearMapPositionsEvent)="clearMapPositions()"
  (getPositionsForDevices)="getPositionsForDevices.emit($event)"
  [mapPositions]="mapPositions()"
  [isMapPage]="true"
></vectronic-device-selector>
